// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { promoWidgetStyles } from "@synd/App/Widgets/Basic/PromoWidget";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { autoClamp, color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

promoWidgetStyles.wrapper = {
    css: css`
        background-color: ${({ backgroundColor }: any) => backgroundColor || color("common.ui7")};
        padding: 8px 32px;
        display: grid;
        grid-template-columns: 1fr 1px 1fr;
        gap: 24px;
        align-items: center;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
            padding: 24px 16px;
        }
    `,
};

promoWidgetStyles.heading = {
    css: css`
        &,
        ${TypographyStyle} {
            font-size: ${autoClamp(22, 22, 24)};
            line-height: ${autoClamp(33, 34, 35)};
            text-align: center;
            margin-bottom: 0;
        }
    `,
};

promoWidgetStyles.content = {
    css: css`
        display: flex;
        gap: 24px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: center;
        }
        ${xScreen("lt", "sm")} {
            gap: 16px;
        }
    `,
};

promoWidgetStyles.description = {
    css: css`
        &,
        ${TypographyStyle} {
            font-size: ${fontConfig.smallSingleLine.size}px;
            line-height: ${fontConfig.smallSingleLine.lineHeight};
            text-align: center;
            margin-bottom: 0;
        }
    `,
};

promoWidgetStyles.button = {
    variant: "secondary",
    css: css`
        text-wrap: nowrap;
        &,
        &&:hover {
            color: ${({ textColor }: any) => textColor } ;
            border-color: ${({ textColor }: any) => textColor || color("common.white")};
            background-color: transparent;
        }
    `,
};

promoWidgetStyles.divider = {
    css: css`
        background-color: ${({ textColor }: any) => textColor || color("common.border")};
        height: 66px;
        width: 1px;
        ${xScreen("lte", "md")} {
            height: 1px;
            width: 100%;
        }
    `,
};
